// import i18n from '../i18n';

export const loaderColor = '#BA2127';
export const loaderColorTgGreen = '#81C43B';
export const loaderColorTgBlue = '#0EC0ED';
export const loaderSize = '1.5em';
export const loaderSizeSm = '1em';
export const loaderSizeXS = '0.5em';
export const lazyImage =
  'https://e6golf-qa-assets.imgix.net/shared/store/e6golf-web-store-header@3x.jpg?blur=200&w=400&h=400&fit=crop';
export const lazyProductImage =
  'https://e6golf-qa-assets.imgix.net/uploads/clubhouses/branding/e6Connect_logo_1.jpg?blur=70&w=300?crop=true';
export const lazyProductImageTG =
  'https://e6golf-assets.imgix.net/products/TG_logo.png?blur=70&w=300?crop=true';
export const lazyProfileImage =
  'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop';
export const defaultProductImage = `https://picsum.photos/500/300?image=${1 * 5 + 10}`;
export const limitedGameModes = ['ClosestToPin', 'LongestDrive'];
export const limitedAltModes = ['Blackout', 'Solaro', 'Darts'];
export const teamModes = ['Scramble', 'scramble', 'Best Ball', 'bestball', 'best_ball', 'BestBall'];
export const scoreCardModes = [
  'Stroke Play',
  'strokeplay',
  'stroke play',
  'stroke_play',
  'StrokePlay',
  'strokePlay',
  'Scramble',
  'scramble',
  'Best Ball',
  'BestBall',
  'bestball',
  'best ball',
  'best_ball',
  'Stableford',
  'stableford',
];
export const attemptOptions = [
  'Closest to the Pin',
  'ClosestToPin',
  'Long Drive',
  'LongestDrive',
  'longestdrive',
  'LongDrive',
  'Long Drive - World Series',
  'LongDriveWorldSeries',
  'longdriveworldseries',
  'Blackout',
  'Solaro',
  'Darts',
  'Solaro - Blackout',
  'Henyett - Darts',
];
export const genderOptions = [
  { text: 'Male', value: 'male' },
  { text: 'Female', value: 'female' },
  { text: 'Undisclosed', value: 'undisclosed' },
];
export const handOptions = [
  { text: 'Right', value: 'right' },
  { text: 'Left', value: 'left' },
];
export const clubEmailOptions = [
  { key: 'no', value: false },
  { key: 'yes', value: true },
];
export const physicalProductTypes = ['simulators', 'tgMini', 'replacementItem'];
export const miniGamesList = [
  'Blackout',
  'Solaro',
  'Darts',
  'Solaro - Blackout',
  'Henyett - Darts',
  'Long Drive - World Series',
];
export const coursesNotIncludedList = [
  'Henyett - Darts',
  'Darts',
  'Blackout',
  'Solaro',
  'Solaro - Blackout',
  'Battle Stations',
  'Long Drive Range',
  'Practice Area Targets',
  'T-Shotz K.C.',
];
export const desktopType = 'Desktop';
export const mobileType = 'Mobile';
export const courseSelectHeaders = [
  { text: '', align: 'left', value: 'imageURL', sortable: false },
  { text: 'Name', align: 'left', value: 'name', sortable: true },
  { text: 'Par', align: 'center', value: 'mensPar', sortable: true },
  {
    text: 'Yardage',
    align: 'center',
    value: 'teeLevels[0].footage',
    sortable: true,
  },
];
export const clubmemberPermissions = ['ADMIN', 'METRICS', 'EMAIL', 'SEASONS'];
export const userPermissions = [
  'USER',
  'LIMITEDUSER',
  'ADMIN',
  'RESELLER',
  'RESELLEREXEMPT',
  'OEMSELLER',
  'ACCOUNTING',
  'DEV',
  'SALES',
  'SUPPORT',
  'ACTIVATIONS',
  'MARKETING',
  'SEASONS',
  'CLUBHOUSE',
  'TRUSIMAPI',
];

// shaft_flex enum [x, s, r, a l]
export const shaftFlexOptions = [
  {
    text: '',
    value: '',
  },
  {
    text: 'X',
    value: 'x',
  },
  {
    text: 'S',
    value: 's',
  },
  {
    text: 'R',
    value: 'r',
  },
  {
    text: 'A',
    value: 'a',
  },
  {
    text: 'L',
    value: 'l',
  },
];
// club_tag enum[draw, fade, neutral, half_swing, three_quarter_swing, chip, punch, flop]
export const clubTagOptions = [
  {
    text: '',
    value: '',
  },
  {
    text: 'Draw',
    value: 'draw',
  },
  {
    text: 'Fade',
    value: 'fade',
  },
  {
    text: 'Neutral',
    value: 'neutral',
  },
  {
    text: 'Half Swing',
    value: 'half_swing',
  },
  {
    text: 'Three Quarter Swing',
    value: 'three_quarter_swing',
  },
  {
    text: 'Chip',
    value: 'chip',
  },
  {
    text: 'Punch',
    value: 'punch',
  },
  {
    text: 'Flop',
    value: 'flop',
  },
];
export const stateList = [
  {
    value: 'AL',
    text: 'Alabama',
  },
  {
    value: 'AK',
    text: 'Alaska',
  },
  {
    value: 'AS',
    text: 'American Samoa',
  },
  {
    value: 'AZ',
    text: 'Arizona',
  },
  {
    value: 'AR',
    text: 'Arkansas',
  },
  {
    value: 'CA',
    text: 'California',
  },
  {
    value: 'CO',
    text: 'Colorado',
  },
  {
    value: 'CT',
    text: 'Connecticut',
  },
  {
    value: 'DE',
    text: 'Delaware',
  },
  {
    value: 'DC',
    text: 'District Of Columbia',
  },
  {
    value: 'FM',
    text: 'Federated States Of Micronesia',
  },
  {
    value: 'FL',
    text: 'Florida',
  },
  {
    value: 'GA',
    text: 'Georgia',
  },
  {
    value: 'GU',
    text: 'Guam',
  },
  {
    value: 'HI',
    text: 'Hawaii',
  },
  {
    value: 'ID',
    text: 'Idaho',
  },
  {
    value: 'IL',
    text: 'Illinois',
  },
  {
    value: 'IN',
    text: 'Indiana',
  },
  {
    value: 'IA',
    text: 'Iowa',
  },
  {
    value: 'KS',
    text: 'Kansas',
  },
  {
    value: 'KY',
    text: 'Kentucky',
  },
  {
    value: 'LA',
    text: 'Louisiana',
  },
  {
    value: 'ME',
    text: 'Maine',
  },
  {
    value: 'MH',
    text: 'Marshall Islands',
  },
  {
    value: 'MD',
    text: 'Maryland',
  },
  {
    value: 'MA',
    text: 'Massachusetts',
  },
  {
    value: 'MI',
    text: 'Michigan',
  },
  {
    value: 'MN',
    text: 'Minnesota',
  },
  {
    value: 'MS',
    text: 'Mississippi',
  },
  {
    value: 'MO',
    text: 'Missouri',
  },
  {
    value: 'MT',
    text: 'Montana',
  },
  {
    value: 'NE',
    text: 'Nebraska',
  },
  {
    value: 'NV',
    text: 'Nevada',
  },
  {
    value: 'NH',
    text: 'New Hampshire',
  },
  {
    value: 'NJ',
    text: 'New Jersey',
  },
  {
    value: 'NM',
    text: 'New Mexico',
  },
  {
    value: 'NY',
    text: 'New York',
  },
  {
    value: 'NC',
    text: 'North Carolina',
  },
  {
    value: 'ND',
    text: 'North Dakota',
  },
  {
    value: 'MP',
    text: 'Northern Mariana Islands',
  },
  {
    value: 'OH',
    text: 'Ohio',
  },
  {
    value: 'OK',
    text: 'Oklahoma',
  },
  {
    value: 'OR',
    text: 'Oregon',
  },
  {
    value: 'PW',
    text: 'Palau',
  },
  {
    value: 'PA',
    text: 'Pennsylvania',
  },
  {
    value: 'PR',
    text: 'Puerto Rico',
  },
  {
    value: 'RI',
    text: 'Rhode Island',
  },
  {
    value: 'SC',
    text: 'South Carolina',
  },
  {
    value: 'SD',
    text: 'South Dakota',
  },
  {
    value: 'TN',
    text: 'Tennessee',
  },
  {
    value: 'TX',
    text: 'Texas',
  },
  {
    value: 'UT',
    text: 'Utah',
  },
  {
    value: 'VT',
    text: 'Vermont',
  },
  {
    value: 'VI',
    text: 'Virgin Islands',
  },
  {
    value: 'VA',
    text: 'Virginia',
  },
  {
    value: 'WA',
    text: 'Washington',
  },
  {
    value: 'WV',
    text: 'West Virginia',
  },
  {
    value: 'WI',
    text: 'Wisconsin',
  },
  {
    value: 'WY',
    text: 'Wyoming',
  },
];

export const yearList = [
  2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005,
  2004, 2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 1995, 1994, 1993, 1992, 1991, 1990, 1989,
  1988, 1987, 1986, 1985, 1984, 1983, 1982, 1981, 1980, 1979, 1978, 1977, 1976, 1975, 1974, 1973,
  1972, 1971, 1970, 1969, 1968, 1967, 1966, 1965, 1964, 1963, 1962, 1961, 1960, 1959, 1958, 1957,
  1956, 1955, 1954, 1953, 1952, 1951, 1950, 1949, 1948, 1947, 1946, 1945, 1944, 1943, 1942, 1941,
  1940, 1939, 1938, 1937, 1936, 1935, 1934, 1933, 1932, 1931, 1930, 1929, 1928, 1927, 1926, 1925,
  1924, 1923, 1922, 1921, 1920, 1919, 1918, 1917, 1916, 1915, 1914, 1913, 1912, 1911, 1910, 1909,
  1908, 1907, 1906, 1905,
];

// Product Options
export const productTypes = [
  {
    text: 'Purchase',
    value: 'purchase',
  },
  {
    text: 'Subscription',
    value: 'subscription',
  },
  {
    text: 'Consumable',
    value: 'consumable',
  },
];

export const productCategories = [
  {
    text: 'All',
    value: '',
  },
  {
    text: 'Course Content',
    value: 'courseContent',
  },
  {
    text: 'Tracking System',
    value: 'trackingSystem',
  },
  {
    text: 'License Subscription',
    value: 'licenseSubscription',
  },
  {
    text: 'User Permission',
    value: 'userPermission',
  },
  {
    text: 'MOP Content',
    value: 'mopContent',
  },
  {
    text: 'Multi Sport',
    value: 'multiSport',
  },
  {
    text: 'Event Content',
    value: 'eventContent',
  },
  {
    text: 'Apogee',
    value: 'apogee',
  },
  {
    text: 'Simulators',
    value: 'simulators',
  },
  {
    text: 'TruGolf Mini',
    value: 'tgMini',
  },
  {
    text: 'Replacement Item',
    value: 'replacementItem',
  },
];

export const subscriptionProductDelayOptions = [
  { text: '1 Day', value: '1 day' },
  { text: '1 Week', value: '7 days' },
  { text: '10 Days', value: '10 days' },
  { text: '1 Month', value: '1 month' },
  { text: '3 Months', value: '3 months' },
  { text: '6 Months', value: '6 months' },
  { text: '1 Year', value: '365 days' },
  { text: '2 Years', value: '730 days' },
];

export const modelTTSOptions = [
  { value: '2EiwWnXFnvU5JabPnv8n', text: 'Clyde' },
  { value: 'CwhRBWXzGAHq8TQ4Fs17', text: 'Roger' },
  { value: 'EXAVITQu4vr4xnSDxMaL', text: 'Sarah' },
  { value: 'FGY2WhTYpPnrIDTdsKH5', text: 'Laura' },
  { value: 'IKne3meq5aSn9XLyUdCD', text: 'Charlie' },
  { value: 'JBFqnCBsd6RMkjVDRZzb', text: 'George' },
  { value: 'N2lVS1w4EtoT3dr4eOWO', text: 'Callum' },
  { value: 'SAz9YHcvj6GT2YYXdXww', text: 'River' },
  { value: 'SOYHLrjzK2X1ezoPC6cr', text: 'Harry' },
  { value: 'TX3LPaxmHKxFdv7VOQHJ', text: 'Liam' },
  { value: 'Xb7hH8MSUJpSbSDYk0k2', text: 'Alice' },
  { value: 'XrExE9yKIg1WjnnlVkGX', text: 'Matilda' },
  { value: 'bIHbv24MWmeRgasZH58o', text: 'Will' },
  { value: 'cgSgspJ2msm6clMCkdW9', text: 'Jessica' },
  { value: 'cjVigY5qzO86Huf0OWal', text: 'Eric' },
  { value: 'iP95p4xoKVk53GoZ742B', text: 'Chris' },
  { value: 'nPczCjzI2devNBz1zQrb', text: 'Brian' },
  { value: 'onwK4e9ZLuTAKqWW03F9', text: 'Daniel' },
  { value: 'pFZP5JQG7iQjIQuC4Bku', text: 'Lily' },
  { value: 'pqHfZKP75CvOlQylNhV4', text: 'Bill' },
  { value: 'oGD7HAeuchSKsCVBhH8d', text: 'Deep Man' },
  { value: 'f7Z23IGxM8XDOXRM1SIx', text: 'Ben Hogan - Venturi' },
  { value: 'dxHwmoKRdrtaJcV6ep3R', text: 'Ben Hogan 2' },
  { value: 'dMacHyWpVljEjsfv5b9H', text: 'Ben Hogan K Venturi J Kelly' },
  { value: 'DowyQ68vDpgFYdWVGjc3', text: 'Jason Chen - Chinese' },
  { value: 'miTHcVblZMXYolDQgUgx', text: 'Nicole' },
  {
    value: 'U7wWSnxIJwCjioxt86mk',
    text: 'Olaniyi Victor - A warm, calming African voice with a rich Lagos Nigerian accent',
  },
  { value: 'zKQW8L9R33870b1uxDcs', text: 'Ben Hogan - Jim Kelly' },
  { value: 'gY6t08jv3UVK3sDzMM1i', text: 'TG-Brenner' },
  { value: 'tV5CCPzKNP5eyptiDwAf', text: 'TG-BenHogan' },
  { value: 'rOQwhVA1Es5m35arCqBe', text: 'Sato' },
  { value: 'V7016qcssmgCGTteclWO', text: 'Valentino' },
  { value: '6fFs9e42k3TPqoYUKJTi', text: 'Ben Hogan' },
  {
    value: '0m1WGWVzxS7KbWobXtnw',
    text: 'Olumide Gbenro - Sports Commentator/Narrator/NBA Voice Over/ Cash Cow Video/ Automation',
  },
];

export const contextTypeOptions = [
  { value: 'player_intro', text: 'Player Intro' },
  { value: 'player_intro_masters_2026', text: 'Player Intro Masters 2026' },
  { value: 'player_on_tee', text: 'Player Stepping Up To Tee' },
  { value: 'kp_shot_valid', text: 'KP Shot Valid' },
  { value: 'kp_shot_invalid', text: 'KP Shot Invalid' },
  {
    value: 'kp_round_complete_player',
    text: 'KP Player Completed Round',
  },
  { value: 'bunker_shot', text: 'Shot Complete Bunker' },
  {
    value: 'near_pin_gir_true_5ft',
    text: 'Shot Near Complete GIR 5ft To Pin',
  },
  {
    value: 'near_pin_gir_true_15ft',
    text: 'Shot Near Complete GIR 15ft To Pin',
  },
  {
    value: 'near_pin_gir_true_30ft',
    text: 'Shot Near Complete GIR 30ft To Pin',
  },
  { value: 'out_of_bounds', text: 'Shot Complete Out Of Bounds' },
  { value: 'round_complete', text: 'Player Completed Round' },
  { value: 'shot_complete_auto_score', text: 'Shot Complete Auto-Score' },
  {
    value: 'shot_complete_ball_in_hole',
    text: 'Shot Complete Ball In Hole',
  },
  { value: 'shot_complete_gimme', text: 'Shot Complete Gimme' },
  {
    value: 'shot_complete_hole_in_one',
    text: 'Shot Complete Hole-In-One',
  },
  {
    value: 'shot_from_tee_150_dif_true',
    text: 'Shot Almost Complete Drive In Fairway 150yds Or Less To Hole',
  },
  {
    value: 'shot_from_tee_180_dif_true',
    text: 'Shot Almost Complete Drive In Fairway 180yds Or Less To Hole',
  },
  { value: 'water_shot', text: 'Water Shot' },
  { value: 'tricky_lie_shot', text: 'Tricky Lie Shot' },
];

export const availableInputFields = [
  { id: 'commentary_uuid', text: 'Commentary UUID', display_order: 1 },
  { id: 'profile_uuid', text: 'Profile UUID', display_order: 2 },
  { id: 'display_name', text: 'Display Name', display_order: 3 },
  { id: 'gender', text: 'Gender', display_order: 4 },
  { id: 'handedness', text: 'Handedness', display_order: 5 },
  { id: 'profession', text: 'Profession', display_order: 6 },
  { id: 'shot_tendency', text: 'Shot Tendency', display_order: 7 },
  { id: 'favorite_sport', text: 'Favorite Sport', display_order: 8 },
  { id: 'favorite_golfer', text: 'Favorite Golfer', display_order: 9 },
  { id: 'experience_level', text: 'Experience Level', display_order: 10 },
  { id: 'mode_of_play', text: 'Mode Of Play', display_order: 11 },
  { id: 'current_attempt', text: 'Current Attempt', display_order: 12 },
  { id: 'max_attempts', text: 'Max Attempts', display_order: 13 },
  {
    id: 'remaining_attempts',
    text: 'Remaining Attempts',
    display_order: 14,
  },
  { id: 'ball_lie', text: 'Ball Lie', display_order: 15 },
  {
    id: 'ball_lie_shot_end',
    text: 'Ball Lie Shot End',
    display_order: 16,
  },
  { id: 'ricochet_type', text: 'Ricochet Type', display_order: 17 },
  { id: 'distance_to_pin', text: 'Distance To Pin', display_order: 18 },
  {
    id: 'distance_to_pin_shot_start',
    text: 'Distance To Pin Shot Start',
    display_order: 19,
  },
  { id: 'current_elevation', text: 'Current Elevation', display_order: 20 },
  { id: 'elevation_to_pin', text: 'Elevation To Pin', display_order: 21 },
  {
    id: 'elevation_shot_start',
    text: 'Elevation Shot Start',
    display_order: 22,
  },
  { id: 'elevation_shot_end', text: 'Elevation Shot End', display_order: 23 },
  {
    id: 'elevation_shot_change',
    text: 'Elevation Shot Change',
    display_order: 24,
  },
  { id: 'current_rank', text: 'Current Rank', display_order: 25 },
  { id: 'previous_rank', text: 'Previous Rank', display_order: 26 },
  { id: 'leaderboard', text: 'Leaderboard', display_order: 27 },
  { id: 'displaced_player', text: 'Displaced Player', display_order: 28 },
  { id: 'course_name', text: 'Course Name', display_order: 29 },
  {
    id: 'num_shots_this_hole',
    text: 'Num Shots This Hole',
    display_order: 30,
  },
  { id: 'score_type', text: 'Score Type', display_order: 31 },
  { id: 'par', text: 'Par', display_order: 32 },
  { id: 'hole_number', text: 'Hole Number', display_order: 33 },
  { id: 'club_type', text: 'Club Type', display_order: 34 },
];
